import { Box, TableCell, alpha, styled } from '@mui/material';

export const FinancedOffersWarningContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
  color: theme.palette.warning.main,
  flexGrow: 1,
  backgroundColor: alpha(theme.palette.warning.main, 0.1),
  borderRadius: '10px',
  padding: theme.spacing(1)
}));

export const FinanacedOffersSummaryProperty = styled('span')(() => ({
  fontSize: 'medium'
}));

export const FinanacedOffersInfoValue = styled('span')(({ theme }) => ({
  color: theme.palette.info.main,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: 'medium'
}));

export const TableCellPadding = styled(TableCell)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1)
}));
